import { useState } from "react";
import { AppLayout } from "@/components/layout/app-layout";
import { PageHeader } from "@/components/layout/page-header";
import { FileUploadZone } from "@/components/file-processor/file-upload-zone";
import { ProcessingQueue } from "@/components/file-processor/processing-queue";
import { AiProcessingAnalysis } from "@/components/file-processor/ai-processing-analysis";
import { UploadHistory } from "@/components/file-processor/upload-history";
import { useAuth } from "@/contexts/auth-context";
import { useActiveMandate } from "@/hooks/use-active-mandate";

const FileProcessor = () => {
  const { organization } = useAuth();
  const { mandate } = useActiveMandate();
  const [refreshKey, setRefreshKey] = useState(0);

  const organizationId = organization?.id;
  const mandateId = mandate?.id;

  const handleUploadComplete = () => {
    setRefreshKey(prev => prev + 1);
  };

  const finalOrgId = organizationId || "demo-org";
  const finalMandateId = mandateId || "demo-mandate";

  return (
    <AppLayout>
      <PageHeader
        title="File Processor"
        subtitle={`${organization?.name || 'Demo Organization'} • ${mandate?.client_name || 'Demo Mandate'}`}
      />
      <main className="flex-1 p-page-padding lg:p-page-padding-lg overflow-y-auto">
        <div className="grid grid-cols-12 gap-section-gap">
          {/* Left Column: Upload & Queue */}
          <div className="col-span-12 lg:col-span-7 flex flex-col gap-section-gap">
            <FileUploadZone
              mandateId={finalMandateId}
              organizationId={finalOrgId}
              onUploadComplete={handleUploadComplete}
            />
            <ProcessingQueue
              mandateId={finalMandateId}
              organizationId={finalOrgId}
              refreshKey={refreshKey}
            />
          </div>

          {/* Right Column: AI & History */}
          <div className="col-span-12 lg:col-span-5 flex flex-col gap-section-gap">
            <AiProcessingAnalysis
              mandateId={finalMandateId}
              organizationId={finalOrgId}
              refreshKey={refreshKey}
            />
            <UploadHistory
              mandateId={finalMandateId}
              organizationId={finalOrgId}
              refreshKey={refreshKey}
            />
          </div>
        </div>
        
        <footer className="mt-header-mb pt-section-gap border-t border-brand-border flex justify-between items-center">
          <p className="text-xs text-brand-text-primary">Copyright © 2024 Swiss Finance OS</p>
          <div className="flex items-center gap-4 text-xs text-brand-text-secondary">
            <span className="hover:text-brand-primary cursor-pointer">Privacy Policy</span>
            <span className="hover:text-brand-primary cursor-pointer">Terms & Conditions</span>
            <span className="hover:text-brand-primary cursor-pointer">Contact</span>
          </div>
        </footer>
      </main>
    </AppLayout>
  );
};

export default FileProcessor;